import {rpAppLink} from "@pg-mono/rp-routes";

import {PricesViewType} from "../helpers/prices_view_type";
import {getDistrictDisplayData} from "./get_district_display_data";

const getOfferTypeUrlPrefix = (type: PricesViewType): string => (type === PricesViewType.HOUSES ? "nowe-domy" : "nowe-mieszkania");

// Same URL pattern as the offer listing's district links: "nowe-mieszkania-{citySlug}-{districtSlug}",
// not the price report's own "?dist=" view.
export const getDistrictListingLink = (district: {slug: string}, citySlug: string, type: PricesViewType): string => {
    const districtSlug = getDistrictDisplayData(district, citySlug).slug;

    return rpAppLink.offer.listFriendly({friendlySlug: `${getOfferTypeUrlPrefix(type)}-${citySlug}-${districtSlug}`});
};
import {rpAppLink} from "@pg-mono/rp-routes";

import {PricesViewType} from "../helpers/prices_view_type";
import {getDistrictDisplayData} from "./get_district_display_data";

const getOfferTypeUrlPrefix = (type: PricesViewType): string => (type === PricesViewType.HOUSES ? "nowe-domy" : "nowe-mieszkania");

// Same URL pattern as the offer listing's district links: "nowe-mieszkania-{citySlug}-{districtSlug}",
// not the price report's own "?dist=" view.
export const getDistrictListingLink = (district: {slug: string}, citySlug: string, type: PricesViewType): string => {
    const districtSlug = getDistrictDisplayData(district, citySlug).slug;

    return rpAppLink.offer.listFriendly({friendlySlug: `${getOfferTypeUrlPrefix(type)}-${citySlug}-${districtSlug}`});
};
